module.exports = __webpack_public_path__ + "static/img/qtywly-zyyypt-01.651a246.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/qtywly-zyyypt-01.png
// module id = QZDt
// module chunks = 1